/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForGcpOauthProtocol extends models.ServiceAccountCredentialsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForGcpOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForGcpOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForGcpOauthProtocol>): ServiceAccountCredentialsBaseForGcpOauthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForGcpOauthProtocol(), model);
        ServiceAccountCredentialsBaseForGcpOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForGcpOauthProtocol>): ServiceAccountCredentialsBaseForGcpOauthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForGcpOauthProtocol.newInstance(<ServiceAccountCredentialsBaseForGcpOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForGcpOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForGcpOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForGcpOauthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForGcpOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

    /**
     * Redirect URI. This is a required field.
     */
    redirect_uri: string;

    /**
     * Authorization Code. This is a required field.
     */
    authorization_code: string;

}
